module.exports = __webpack_public_path__ + "img/traveller-active.dec130fa.svg";